import { isNativePlatform } from "../capacitor/platform";
import { getServerUrl } from "../capacitor/server-url";
import { getSessionToken } from "../capacitor/session-token";
import { peekClientFingerprint } from "./fingerprint";

// The session is an HttpOnly cookie on web and a bearer token on native.
export interface RequestContext {
  baseUrl: string;
  headers: Record<string, string>;
  credentials: RequestCredentials;
}

const API_BASE = "/api";

export async function requestContext(): Promise<RequestContext> {
  const headers: Record<string, string> = {};

  // Only a value already computed is read, so a request never waits for it.
  const fp = peekClientFingerprint();
  if (fp?.hash) headers["X-Client-Fingerprint"] = fp.hash;
  if (fp?.data) headers["X-Client-Fingerprint-Data"] = fp.data;

  if (!isNativePlatform()) {
    return { baseUrl: API_BASE, headers, credentials: "include" };
  }

  const serverUrl = await getServerUrl();
  // Login and token exchange then return the session token in the body, with no Set-Cookie.
  headers["X-Client-Type"] = "native";
  const token = await getSessionToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;
  return { baseUrl: serverUrl ? `${serverUrl}${API_BASE}` : API_BASE, headers, credentials: "omit" };
}
